<template>
  <div class="wrap">
    <div class="header_title">
      <div class="header_center">
        <div class="title">
          申报奖项:
          <span>2021年半年报</span>
        </div>
        <div class="back_page" @click="backpage">返回上一页</div>
      </div>
    </div>
    <div class="form_box">
      <div class="nav_left">
        <div class="nav_title">导航</div>
        <div class="nav_list">
          <!-- 导航栏列表 -->
          <div
            class="list"
            v-for="(item, index) in lefttitlelist"
            :key="index"
            @click="scrollleft(item.elementid)"
          >
            <img class="tips" v-if="item.isok" src="@/assets/6598@2x.png" alt />
            <img class="tips" v-else src="@/assets/6668@2x.png" alt />
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div class="preview">
          <!-- 左边三个按钮 -->
          <div class="preservation" @click="SaveDraftleft">
            <img src="@/assets/19158@2x.png" alt />
            <p>保存草稿</p>
          </div>
          <div class="online" @click="printPdf">
            <img src="@/assets/19160@2x.png" alt />
            <p>在线预览</p>
          </div>
          <div
            class="sumbit"
            :class="issumbit ? 'blue' : ''"
            v-btn-control="sumbit"
          >
            <img src="@/assets/19178@2x.png" alt />
            <p>提交平台审核</p>
          </div>
        </div>
      </div>
      <div class="form_right" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="title">
          <Tips
            title="填表须知"
            background="#EDF8F5"
            border="#1ABF98"
            :states="true"
          ></Tips>
          <div
            class="form_box_content"
            style="text-align: start; font-size: 14px; color: #0c0d0f"
          >
            <p>
              1、本企业郑重承诺所填数据皆为真实数据，无不实、捏造、造假情况，对上传所有内容负责；<br />
              2、注册类人员包括一、二级注册建造师、注册造价师、注册监理工程师、注册安全工程师、注册会计师。（若一人有多种执业资格，只计算一次）<br />
              3、中、高级技工指企业内从事相关工种，包括瓦工、钢筋工、混凝土工、抹灰工、防水工、管道工、水暖工、测量放线工、木工、电焊工、油漆工、安装起重工、电气设备安装调试工、工程机械维修工、中小型机械操作工等，经市级以上建筑职业技能岗位主管部门培训考核，取得中级技工及以上级别的人员。<br />
              4、所有内容只限于调研分析所用，将会严格保密。在填写过程中有任何疑问请致电：0851-85360455；<br />
            </p>
          </div>
        </div>
        <div class="form_1" id="Enterpriseoverview">
          <Tips
            title="企业概况"
            :background="Enterpriseoverview ? '#EDF8F5' : '#FEF8EF'"
            :border="Enterpriseoverview ? '#1ABF98' : '#FFB700'"
            :states="Enterpriseoverview"
          ></Tips>
          <div class="my_form" style="margin-top: 20px">
            <div class="form_title" style="height: 62px">企业全称</div>
            <div class="form_long">
              <input
                placeholder="请输入"
                type="text"
                v-model="parmes.Enterpriseoverview.msg1"
              />
            </div>
          </div>
          <div class="my_form2">
            <div class="form_title" style="height: 62px">注册地址</div>
            <div class="form_long">
              <input
                placeholder="请输入"
                type="text"
                v-model="parmes.Enterpriseoverview.msg2"
              />
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">填表人</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Enterpriseoverview.msg3"
                  />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">联系电话</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Enterpriseoverview.msg4"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">企业性质</div>
              <div class="form_content">
                <el-select
                  v-model="parmes.Enterpriseoverview.msg5"
                  placeholder="请选择企业性质"
                  class="inpyabeb"
                  size="small"
                >
                  <el-option label="中央企业" value="中央企业"></el-option>
                  <el-option
                    label="省属国有企业"
                    value="省属国有企业"
                  ></el-option>
                  <el-option label="民营企业" value="民营企业"></el-option>
                  <el-option label="集体企业" value="集体企业"></el-option>
                  <el-option
                    label="混合所有制企业"
                    value="混合所有制企业"
                  ></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                企业资质类型及等级
              </div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Enterpriseoverview.msg6"
                  />
                </div>
                <!-- <el-select
                  v-model="parmes.Enterpriseoverview.msg6"
                  placeholder="请选择企业性质"
                  class="inpyabeb"
                  size="small"
                >
                  <el-option label="施工总承包特级" value="施工总承包特级"></el-option>
                  <el-option
                    label="施工总承包一级"
                    value="施工总承包一级"
                  ></el-option>
                  <el-option label="施工总承包二级及以下" value="施工总承包二级及以下"></el-option>
                  <el-option label="专业承包一级" value="专业承包一级"></el-option>
                  <el-option
                    label="专业承包二级"
                    value="专业承包二级"
                  ></el-option>
                  <el-option label="专业承包二级以下" value="专业承包二级以下"></el-option>
                  <el-option label="劳务分包一级" value="劳务分包一级"></el-option>
                  <el-option label="劳务分包二级" value="劳务分包二级"></el-option>
                  <el-option label="劳务分包二级以下" value="劳务分包二级以下"></el-option>
                </el-select> -->
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Operation">
          <Tips
            title="企业生产经营情况"
            :background="Operation ? '#EDF8F5' : '#FEF8EF'"
            :border="Operation ? '#1ABF98' : '#FFB700'"
            :states="Operation"
          ></Tips>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">完成总产值</div>
              <div class="form_content">
                <div class="input">
                  <input
                    placeholder="请输入"
                    type="text"
                    v-model="parmes.Operation.msg1"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">应收账款</div>
              <div class="form_content">
                <div class="input">
                  <input
                    placeholder="请输入"
                    type="text"
                    v-model="parmes.Operation.msg2"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">现金流</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg3"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form my_formmin">
              <div class="form_title">实现利润</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg4"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">总资产</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg5"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">资产负债率</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg6"
                  />
                  <span>%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form_title">
            <p style="text-align: start; margin: 20px 0">业务结构</p>
          </div>
          <div class="flex">
            <div class="my_form2 my_form2min">
              <div class="form_title">建筑施工</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg7"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bord">
            <img src="@/assets/51@2x.png" alt="" />
          </div>
          <div class="flex">
            <div class="my_form my_formmin">
              <div class="form_title">住宅类项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg8"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">公共类项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg9"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">工业类项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg10"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2 my_form2min">
              <div class="form_title">装配式混凝土项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg11"
                  />
                  <span>万平方米</span>
                </div>
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg12"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">装配式钢结构项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg13"
                  />
                  <span>万平方米</span>
                </div>
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg14"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form my_formmin">
              <div class="form_title">市政施工</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg15"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bord">
            <img src="@/assets/51@2x.png" alt="" />
          </div>
          <div class="flex">
            <div class="my_form2 my_form2min">
              <div class="form_title">城市道路项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg16"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">轨道交通项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg17"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">地下管廊（线）项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg18"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form my_formmin">
              <div class="form_title">绿化景观项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg19"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">污水（垃圾）处理项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg20"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">其他项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg21"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 111px; margin-top: 20px">
            <div class="my_form2 my_formmin">
              <div class="form_title">房地产开发</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg22"
                  />
                  <span>万㎡</span>
                </div>
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg23"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">铁路施工</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg24"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">公路施工</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg25"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form my_formmin">
              <div class="form_title">电力施工</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg26"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">煤炭施工</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg27"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">冶金施工</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg28"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form2 my_formmin">
              <div class="form_title">石油化工施工</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg29"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">建材装饰施工</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg30"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">水利施工</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg31"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 111px; margin-top: 20px">
            <div class="my_form my_formmin">
              <div class="form_title">海外项目</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg32"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">PPP项目数量及投资额</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg33"
                  />
                  <span>个</span>
                </div>
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg34"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">其他</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.Operation.msg35"
                  />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="innovate">
          <Tips
            title="科技创新与人才队伍"
            :background="innovate ? '#EDF8F5' : '#FEF8EF'"
            :border="innovate ? '#1ABF98' : '#FFB700'"
            :states="innovate"
          ></Tips>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">获得国家级奖项数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    placeholder="请输入"
                    type="text"
                    v-model="parmes.innovate1"
                  />
                  <span>个</span>
                </div>
              </div>
            </div>
          </div>
          <div class="my_form">
            <div class="form_title" style="height: 188px; text-align: center">
              获得国家级奖项名称
            </div>
            <div class="form_textarea">
              <textarea
                name
                id
                cols="30"
                rows="10"
                placeholder="请输入"
                v-model="parmes.innovate2"
              ></textarea>
            </div>
          </div>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">获得省、市级奖项数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    placeholder="请输入"
                    v-model="parmes.innovate3"
                    type="text"
                  />
                  <span>个</span>
                </div>
              </div>
            </div>
          </div>
          <div class="my_form">
            <div class="form_title" style="height: 188px; text-align: center">
              获得省、市级奖项名称
            </div>
            <div class="form_textarea">
              <textarea
                name
                id
                cols="30"
                rows="10"
                placeholder="请输入"
                v-model="parmes.innovate4"
              ></textarea>
            </div>
          </div>
          <!-- <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">获得专利数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    placeholder="请输入"
                    v-model="parmes.innovate5"
                    type="text"
                  />
                  <span>个</span>
                </div>
              </div>
            </div>
          </div> -->
          <div class="my_form" style="margin-top: 20px">
            <div class="form_title" style="height: 188px; text-align: center;">
              发明专利数量及名称
            </div>
            <div class="form_textarea">
              <textarea
                name
                id
                cols="30"
                rows="10"
                placeholder="请输入"
                v-model="parmes.innovate6"
              ></textarea>
            </div>
          </div>
          <div class="my_form2">
            <div class="form_title" style="height: 188px; text-align: center">
              实用新型专利数量及名称
            </div>
            <div class="form_textarea">
              <textarea
                name
                id
                cols="30"
                rows="10"
                placeholder="请输入"
                v-model="parmes.innovate7"
              ></textarea>
            </div>
          </div>
          <div class="flex" style="height: 111px; margin-top: 20px">
            <div class="my_form my_formmin">
              <div class="form_title">高新技术及科技研发投入</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate8"
                  />
                  <span>万元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">技术中心级别和数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate9"
                  />
                  <span></span>
                </div>
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate10"
                  />
                  <span>个</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">行政管理人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate11"
                  />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form2 my_formmin">
              <div class="form_title">接收应届毕业生数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate12"
                  />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">专职科技研发人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate13"
                  />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">院士数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate14"
                  />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form my_formmin">
              <div class="form_title">技能大师数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate15"
                  />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">博士学历人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate16"
                  />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">硕士学历人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate17"
                  />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form2 my_formmin">
              <div class="form_title">注册类人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate18"
                  />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">中、高级职称人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate19"
                  />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">中、高级技工数量</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="parmes.innovate20"
                  />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="form_1" id="Upload">
          <Tips
            title="上传附件"
            :background="filelist.length ? '#EDF8F5' : '#FEF8EF'"
            :border="filelist.length ? '#1ABF98' : '#FFB700'"
            :states="filelist.length ? true : false"
          ></Tips>
          <div class="my_form2">
            <div class="form_title" style="height: 100px">上传附件</div>
            <div class="uploadcertificate">
              <el-upload
                class="upload-demo"
                :action="$baseURL + '/api/home/upload/file/user'"
                :on-change="handleChange"
                :on-remove="handleremove"
                :file-list="filelist"
                accept=".jpg, .png, .pdf, .doc, .docx"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div
                  slot="tip"
                  class="el-upload__tip"
                  v-if="filelist.length < 1"
                >
                  只能上传doc/docx文件，且不超过2mb
                </div>
              </el-upload>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import {
  achievement_report_temp,
  AddAchievementReport,
  achievement_report_temp_detail,
} from "../../utils/api";
import Footer from "@/components/Footer";
import Tips from "@/components/Modal/tips"; //提示组件
export default {
  components: {
    Tips,
    Footer,
  },
  data() {
    return {
      issumbit: true, //是否可以提交审核
      title: true, //填表须知 绿色高亮
      Enterpriseoverview: false, //企业概况 填空是否填完
      Operation: false, //企业生产经营情况 填空是否填完
      innovate: false, //科技创新与人才队伍 填空是否填完
      filelist: [],
      time:undefined,
      lefttitlelist: [
        { name: "填表须知", isok: true, elementid: "title" },
        { name: "企业概况", isok: false, elementid: "Enterpriseoverview" },
        { name: "企业生产经营情况", isok: false, elementid: "Operation" },
        { name: "科技创新与人才队伍", isok: false, elementid: "innovate" },
        // { name: "上传附件", isok: false, elementid: "Upload" },
      ],
      parmes: {
        Enterpriseoverview: {},
        Operation: {},
      },
    };
  },
  created() {
    achievement_report_temp_detail(this.$route.query.id).then((res) => {
      if (Array.isArray(res.content.Enterpriseoverview)) {
        res.content.Enterpriseoverview = {};
      }
      if (Array.isArray(res.content.Operation)) {
        res.content.Operation = {};
      }
      this.filelist = res.content.filelist;
      console.log("myres", res);
      this.time = res.created_at
      this.parmes = res.content;
      console.log(this.time)
    });
    this.lefttitlelist.forEach((element) => {
      if (!element.isok) {
        this.issumbit = false;
      }
    });
  },
  watch: {
    parmes: {
      handler: function (newval, oldval) {
        this.issumbit = true;
        this.Enterpriseoverview = this.noempty(
          this.parmes.Enterpriseoverview,
          6,
          "msg"
        );
        this.Operation = this.noempty(this.parmes.Operation, 35, "msg");
        this.innovate = this.noempty(this.parmes, 20, "innovate");
        this.lefttitlelist[1].isok = this.Enterpriseoverview;
        this.lefttitlelist[2].isok = this.Operation;
        this.lefttitlelist[3].isok = this.innovate;
        this.lefttitlelist[4].isok = this.parmes.filelist
          ? this.parmes.filelist.length >= 1
            ? true
            : false
          : false;
        this.lefttitlelist.forEach((element) => {
          if (!element.isok) {
            this.issumbit = false;
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    //左侧导航栏锚点
    scrollleft(id) {
      this.scrollnum("#" + id);
    },
    //锚点滚动
    scrollnum(id) {
      document
        .querySelector(id)
        .scrollIntoView({ behavior: "smooth", block: "start" });
      // document.querySelector(id).scrollIntoView(true)
      // document.documentElement.scrollTop = document.documentElement.scrollTop - 78
    },
    //非空验证 参数：根据对象名，对象内有多少条属性，属性名
    noempty(obj, num, name) {
      var empty = true;
      for (let i = 1; i <= num; i++) {
        if (obj[name + i] == "" || obj[name + i] == undefined) {
          empty = false;
        }
      }
      return empty;
    },
    //上传附件
    handleChange(file) {
      this.filelist = [file];
      this.$set(this.parmes, "filelist", this.filelist);
    },
    //删除附件
    handleremove() {
      this.filelist = [];
      this.$set(this.parmes, "filelist", []);
    },
    //返回上一页
    backpage() {
      this.$router.go(-1);
    },
    //保存草稿
    SaveDraftleft() {
      this.parmes.filelist = this.filelist;
      achievement_report_temp({
        achievement_id: this.$route.query.id,
        content: this.parmes,
      }).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: "保存草稿成功!",
          });
        }
      });
    },
    //在线预览
    async printPdf() {
      achievement_report_temp({
        achievement_id: this.$route.query.id,
        content: this.parmes,
      }).then((res) => {
        if (res) {
        }
      });
      sessionStorage.setItem("parameters", JSON.stringify(this.parmes));
      sessionStorage.setItem("parameters_time", this.time);
      this.$router.push("/word_1?title=2021年半年报");
    },
    //提交审核
    sumbit() {
      if (this.issumbit) {
        AddAchievementReport({
          achievement_id: this.$route.query.id,
          content: this.parmes,
        }).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: "申报业绩成功!",
            });
          }
        });
      } else {
        this.$message.error("请填写完所有资料再提交");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  width: 100%;
  background: #eff3f8;
  .newadd {
    width: 100px;
    height: 36px;
    border: 1px solid #194abe;
    border-radius: 3px;
    text-align: center;
    line-height: 36px;
    color: #194abe;
    margin: 0 0 20px 20px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .my_form,
  .my_form2 {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: auto;
    align-items: stretch;
    .form_title {
      background: #eaf0f6;
      width: 129px;
      min-width: 129px;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 20px;
      padding: 0 6px;
      box-sizing: border-box;
      color: #0c0d0f;
    }
    .uploadinput {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .uploadlist {
        display: flex;
        align-items: center;
      }
      input {
        width: 257px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #bdc3cb;
        opacity: 1;
        border-radius: 4px;
        padding: 0 15px;
        box-sizing: border-box;
        &:focus {
          outline: none;
          border: 1px solid #194abe;
        }
      }
      .input {
        width: 257px;
        display: flex;
        position: relative;
        display: flex;
        align-items: center;
        margin-left: 20px;
        span {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .form_content,
    .form_long,
    .form_choice {
      width: 300px;
      padding: 0px 6px;
      background: #f5f8fb;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      input {
        width: 257px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #bdc3cb;
        opacity: 1;
        border-radius: 4px;
        padding: 0 15px;
        box-sizing: border-box;
        &:focus {
          outline: none;
          border: 1px solid #194abe;
        }
      }
      .input {
        width: 257px;
        display: flex;
        position: relative;
        span {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .form_choice_long {
      display: flex;
      justify-content: start;
      align-items: center;
      width: 729px;
      padding-left: 20px;
      box-sizing: border-box;
      background: #f5f8fb;
    }
    .form_long {
      width: 729px;
      input {
        width: 688px;
      }
    }
    .form_textarea {
      width: 729px;
      height: 188px;
      display: flex;
      background: #f5f8fb;
      flex-direction: column;
      justify-content: space-evenly;
      padding-left: 20px;
      textarea {
        width: 688px;
        height: 127px;
        background: #ffffff;
        border: 1px solid #bdc3cb;
        opacity: 1;
        border-radius: 4px;
        padding: 9px 15px;
        box-sizing: border-box;
        color: #000;
        &:focus {
          outline: none;
          border: 1px solid #194abe;
        }
      }
    }
    .uploadimg {
      width: 729px;
      padding: 20px;
      background: #f5f8fb;
      box-sizing: border-box;
    }
    .Downinpustyle {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      background: #f5f8fb;
      .nejje {
        color: #194abe !important;
      }
    }
    .upload-demo {
      width: 729px;
      padding-left: 20px;
      background: #f5f8fb;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      height: 100px;
      .el-upload__tip {
        margin-left: 10px;
      }
    }
  }
  .my_formmin,
  .my_form2min {
    width: 286px;
    .form_title {
      width: 86px;
      min-width: 86px;
      padding: 20px 5px;
    }
    .form_content {
      width: 200px;
      display: flex;
      flex-direction: column;
    }
    input,
    .input {
      width: 171px !important;
      margin: 5px 0;
    }
  }
  .my_form {
  }
  .my_form2 {
    .form_title {
      background: #f5f8fb;
    }
    .form_content,
    .form_long,
    .form_textarea,
    .form_choice,
    .form_choice_long,
    .upload-demo,
    .Downinpustyle {
      background: #fbfdff;
    }
  }

  //   顶部title样式
  .header_title {
    width: 100%;
    margin: 0 auto;
    height: 58px;
    background: #ffffff;
    box-shadow: 0px 6px 12px rgba(0, 17, 58, 0.06);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    .header_center {
      width: 1200px;
      margin: 0 auto;
      height: 58px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 29px;
        color: #0c0d0f;
        span {
          font-size: 22px;
          line-height: 32px;
          color: #194abe;
        }
      }
      .back_page {
        cursor: pointer;
        width: 124px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #c8cdd5;
        opacity: 1;
        border-radius: 6px;
        line-height: 36px;
        color: #7c828a;
      }
    }
  }

  // form_box样式
  .form_box {
    max-width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 78px;
    display: flex;
    justify-content: space-between;
    .tips {
      width: 20px;
      height: 20px;
    }
    .nav_left,
    .form_right {
      border-radius: 6px;
    }
    .nav_left {
      position: fixed;
      width: 268px;
      .nav_title,
      .nav_list {
        background: #ffffff;
        width: 100%;
        text-align: start;
        padding: 0 16px;
        box-sizing: border-box;
      }
      .nav_title {
        height: 53.5px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 53.5px;
        color: #0c0d0f;
        border-radius: 6px 6px 0px 0px;
      }
      .nav_list {
        margin-top: 2px;
        height: 350px;
        overflow-y: scroll;
        overflow-x: hidden;
        border-radius: 0px 0px 6px 6px;
        &::-webkit-scrollbar {
          width: 6px;
          height: 1px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background-color: #b7c8f1;
        }
        .list {
          width: 100%;
          height: 57px;
          border-bottom: 1px dashed #d4dbdd;
          display: flex;
          align-items: center;
          p {
            margin-left: 13px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: 24px;
            overflow: hidden;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
      .preview {
        margin-top: 17px;
        width: 100%;
        height: 201px;
        padding: 16px;
        box-sizing: border-box;
        background: white;
        border-radius: 0px 0px 6px 6px;
        .preservation,
        .online,
        .sumbit {
          cursor: pointer;
          width: 236px;
          height: 50px;
          background: #ffffff;
          opacity: 1;
          border-radius: 4px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 15px;
            height: 15px;
            margin-right: 4px;
          }
        }
        .blue {
          background: #194abe !important;
        }
        .preservation {
          border: 1px solid #194abe;
          color: #194abe;
        }
        .online {
          margin: 10px 0;
          border: 1px solid #1abf98;
          color: #1abf98;
        }
        .sumbit {
          background: #d4dbdd;
          border-radius: 4px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 27px;
          color: #ffffff;
          img {
            width: 18px;
            height: 14px;
          }
        }
      }
    }
    .form_right {
      margin-left: 300px;
      width: 918px;
      .flex {
        display: flex;
      }
      .flex-direction {
        flex-direction: column;
      }
      .form_1 {
        width: 100%;
        background: #ffffff;
        padding: 35px 30px;
        box-sizing: border-box;
        margin-bottom: 30px;
        border-radius: 6px;
        .border {
          border-top: 1px dashed #9fa5ae;
          margin: 20px 0;
        }
        .bord {
          margin-top: 11px;
          width: 858px;
          height: 0px;
          border: 1px solid #194abe;
          position: relative;
          img {
            width: 11px;
            height: 6px;
            position: absolute;
            top: -6px;
            left: 37px;
          }
        }
        .newlybuild {
          margin: 0 auto;
          cursor: pointer;
          width: 221px;
          height: 36px;
          border: 2px solid #194abe;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-right: 7px;
          }
          p {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 14px;
            color: #194abe;
          }
        }
        .form_box_content {
          width: 100%;
          margin-top: 20px;
          .form_title {
            box-sizing: border-box;
            text-align: start;
            display: flex;
            align-items: center;
            p {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              line-height: 20px;
              color: #0c0d0f;
            }
            .delete_icon {
              cursor: pointer;
              margin-left: 10px;
              width: 61px;
              height: 25px;
              background: #ffffff;
              border: 1px solid #f9656f;
              opacity: 1;
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: space-evenly;
              img {
                width: 13px;
                height: 14px;
              }
              p {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                line-height: 20px;
                color: #f9656f;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.el-message,
.el-message--error {
  z-index: 999999 !important;
}
.el-upload-list {
  /*height: 50px;*/
  /*display: flex;*/
  /*align-items: center;*/
}
.el-upload-list__item {
  /*transition: none !important;*/
}
</style>
